import React from 'react';

import ErrorBoundary from '@/components/errorBoundary';
import Radar from './App';
import render from '../index';

render(
  <ErrorBoundary>
    <Radar />
  </ErrorBoundary>,
);
